// Module
var code = "<div class=\"js-tercera-label {{additionalClass}}\"\r\n     {{^enabled}}disabled=\"\" {{/}}\r\n     style=\"{{>visibility}}{{style}} {{#if isPosAbsolute}}position: absolute; {{>position}}{{/if}}\">\r\n    {{{innerHTML}}}\r\n</div>";
// Exports
export default code;